import { render, staticRenderFns } from "./data-general.vue?vue&type=template&id=572c5a02&scoped=true&"
import script from "./data-general.vue?vue&type=script&lang=js&"
export * from "./data-general.vue?vue&type=script&lang=js&"
import style0 from "./data-general.vue?vue&type=style&index=0&id=572c5a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c5a02",
  null
  
)

export default component.exports